import { useQuery } from '@tanstack/react-query';

import {
  getV1DomainByIdOptions,
  getV1DomainsOptions,
} from '../../../api/generated/pap/@tanstack/react-query.gen';

/**
 * Query hooks for the Domain Registration feature. See
 * `../IdentityProviders/identityProviders.queries.ts` for the pattern.
 */

export const useDomains = () => useQuery(getV1DomainsOptions());

export const useDomain = (id?: string) =>
  useQuery({
    ...getV1DomainByIdOptions({ path: { id: id ?? '' } }),
    enabled: !!id,
  });
